module.exports = __webpack_public_path__ + "img/5.f2e12a16.png";